import { environmentBase } from './environment.base';
import { Environment } from './environment.model';
import { AuthUtils } from '@libs/core/auth';

export const environment: Environment = {
  ...environmentBase,

  apiUrl: 'https://maurelli-fma-api-staging.zupit.software',
  auth: {
    ...environmentBase.auth,
    ...AuthUtils.buildStandardAzureADB2CEndpoints('maurellifmastaging', 'B2C_1_SignIn'),
    appId: '3f8a4d1e-fa98-4483-85c4-c90dc29d38c7',
    scope: 'offline_access https://maurellifmastaging.onmicrosoft.com/app-api/access_api',
    logoutUrl: 'https://maurellifmastaging.b2clogin.com/maurellifmastaging.onmicrosoft.com/B2C_1_SignIn/oauth2/v2.0/logout',
    web: {
      redirectUrl: 'https://maurelli-fma-staging.zupit.software',
      windowOptions: 'height=600,left=0,top=0',
    },
    android: {
      redirectUrl: 'msauth://com.maurelligroup.fma/2jmj7l5rSw0yVb%2FvlWAYkK%2FYBwk%3D',
    },
    ios: {
      pkceEnabled: true, // workaround for bug https://github.com/moberwasserlechner/capacitor-oauth2/issues/111
      redirectUrl: 'msauth.com.maurelligroup.fma://auth',
    },
  },
  storage: {
    url: 'https://maurelli-fma-storage-staging.zupit.software',
    assetsFolderName: 'mobile-assets',
    reportTypesFolderName: 'report-types',
    vehicleTypesFolderName: 'vehicle-types',
  },
  appEnvironment: 'staging',
  sentry: {
    enable: true,
    dsn: 'https://6bb7a5f9bfe688b122f94c5f56ee6389@sentry.monitoring.zupit.software/3',
  },
};
